import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../axios";
import Alert from "react-s-alert";
import CustomModal from "../../components/CustomModal";
import moment from "moment";
import qs from "qs";
import Paging from "../../components/Paging";
import DatePicker from "react-datepicker";
import ModalHelp from "../../components/ModalHelp";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

class Lists extends Component {
  constructor() {
    super();
    this.state = {
      dataReport: [],
      pageCount: 0,
      currentPage: 0,
      user_id: "",
      tipe_id: "",
      tutorial: "",
      isModalHelpShow: false,
      isLoading: true,
      isButtonLoading: false,
      isModalShow: false,
      sortName: "",
      sortOrder: "",
      startNo: 1,
    };

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
    this.toggleModalHelp = this.toggleModalHelp.bind(this);
  }
  toggleModalHelp() {
    this.setState({ tutorial: "https://www.youtube.com/embed/1mL3jt9ot-k" });

    this.setState({ isModalHelpShow: !this.state.isModalHelpShow });
  }

  toggleModal() {
    this.setState({ isModalShow: !this.state.isModalShow });
  }

  handleSubmitDeleteButton() {
    axios({
      method: "get",
      url: "/iuran/tipe/delete/" + this.state.tipe_id,
    })
      .then((response) => {
        const result = response.data;

        Alert.success(result.message, {
          position: "bottom-right",
        });
        this.loadData();
        this.toggleModal();

        return;
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handlePageClick(data) {
    let selected = data.selected; // zero based index

    this.setState({ currentPage: selected }, () => {
      this.loadData();
    });
  }

  loadData() {
    this.setState({ isLoading: true, isButtonLoading: true });

    const params = qs.stringify({
      page: this.state.currentPage + 1,
      user: this.state.user_id,
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
    });

    axios
      .get("/iuran/tipe?" + params)

      .then((response) => {
        const result = response.data;

        if (result.success === true) {
          this.setState({
            dataReport: result.data.data,
            pageCount: result.data.last_page,
            isLoading: false,
            isButtonLoading: false,
            startNo: result.data.from,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
          });
        } else {
          Alert.error(result.message, {
            position: "bottom-right",
          });
          this.setState({ isLoading: false });
        }
      })

      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!", {
          position: "bottom-right",
        });
      });
  }

  componentDidMount() {
    if (
      localStorage.SISMART_USER_LEVEL !== "administrator" &&
      localStorage.SISMART_USER_LEVEL !== "keuangan"
    ) {
      this.props.history.replace("/dashboard");
    }
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sortName !== this.state.sortName ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.loadData();
    }
  }

  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder,
    });
  }

  formatOpsi(cell, row, enumObject, index) {
    const url = this.props.match.url;
    return (
        <div>
          <NavLink
              to={`${url}/edit/${row.tipe_id}`}
              className="btn btn-primary btn-sm"
              style={{ margin: 3, borderRadius: 3 }}
          >
            Edit{" "}
          </NavLink>

          <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => {
                this.toggleModal();
                this.setState({ tipe_id: row.tipe_id });
              }}
          >
            Hapus
          </button>
        </div>
    );
  }

  render() {
    const strt = this.state.startNo;
    const url = this.props.match.url;

    function indexN(cell, row, enumObject, index) {
      return <div>{index + strt}</div>;
    }

    const options = {
      clearSearch: true,
      searchPosition: "left",
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
      onSortChange: this.onSortChange.bind(this),
    };

    return (
      <div className="col-sm-12">
        <ModalHelp
          isShow={this.state.isModalHelpShow}
          toggleModal={this.toggleModalHelp}
          modalHeaderText="Tutorial Penggunaan Fitur"
          modalBodyText={this.state.tutorial}
          modalSubmitText="Ya"
        />
        <CustomModal
          isShow={this.state.isModalShow}
          toggleModal={this.toggleModal}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Hapus Data"
          modalBodyText="Anda yakin ingin menghapus data ini?"
          modalSubmitText="Ya"
        />

        <div className="card">
          <div className="card-header">
            Jenis Tagihan
            <button
              type="button"
              title="Tutorial"
              className="btn btn-danger btn-sm"
              style={{ float: "right" }}
              onClick={() => {
                this.toggleModalHelp();
                // this.setState({ tutorial: levelName});
              }}
            >
              <i className="fa fa-question-circle" s></i>
            </button>
          </div>
          <div className="card-block">
            <div className="form-group row">
              <div className="col-md-2">
                <NavLink
                  to={`${this.props.match.url}/add`}
                  className="btn btn-primary btn-sm"
                  style={{ margin: 3, borderRadius: 3 }}
                >
                  Tambah Data Baru
                </NavLink>
              </div>
            </div>
            <hr />
            {this.state.isLoading ? (
              "Memuat Data..."
            ) : this.state.dataReport.length === 0 ? (
              "Data tidak ditemukan..."
            ) : (
              <div>
                <BootstrapTable
                  data={this.state.dataReport}
                  striped
                  hover
                  remote
                  options={options}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="question_id"
                    dataFormat={indexN}
                    isKey
                  >
                    No
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="tipe_nama" dataSort width="200">
                    Jenis Tagihan
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="tipe_desc" dataSort width="200">
                    Deskripsi
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="any"
                    dataFormat={this.formatOpsi.bind(this)}
                    width="150"
                  >
                    Opsi
                  </TableHeaderColumn>
                </BootstrapTable>
                <hr />
                <Paging
                  handlePageClick={this.handlePageClick}
                  pageCount={this.state.pageCount}
                  currentPage={this.state.currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/JenisIuran/Lists.js